import * as React from "react";
import { toINR } from "../../../../service/numberFormat";
import { marginCollateralHeading } from "../../marginConstants";
import { ISortProps } from "../../../../types/components/margin/marginTypes";
import MarginSort from "../../generic/marginSort";
import NoDataContainer from "../../../../generic/noDataContainer";

export interface IMarginCollateralTableDskProps {
	tableData: Array<any>;
	filteredData: Array<any>;
	numOfRows: number;
	sortProps: ISortProps;
	setTableData: (tableData: Array<any>) => void;
}

const MarginCollateralTableDsk: React.FC<IMarginCollateralTableDskProps> = props => {
	return (
		<div className="mrgn_coll_tbl table">
			<ul className="hdr_row">
				<li className="tr">
					<div className="td EdelCode">
						<span className="sort_cont">
							<MarginSort
								sortList={props.filteredData}
								sortedColName={props.sortProps.sortedColumnState.colName}
								sortKey="EdelCode"
								onSort={props.sortProps.onSort}
								colName={marginCollateralHeading.edelCode}
							/>
						</span>
					</div>
					<div className="td Companyname">
						<span className="sort_cont">
							<MarginSort
								sortList={props.filteredData}
								sortedColName={props.sortProps.sortedColumnState.colName}
								sortKey="Companyname"
								onSort={props.sortProps.onSort}
								colName={marginCollateralHeading.companyname}
							/>
						</span>
					</div>
					<div className="td Haircut right">
						<span className="sort_cont">
							<MarginSort
								sortList={props.filteredData}
								sortedColName={props.sortProps.sortedColumnState.colName}
								sortKey="Haircut"
								onSort={props.sortProps.onSort}
								colName={marginCollateralHeading.haircut}
							/>
						</span>
					</div>
				</li>
			</ul>

			{props.tableData.length ? (
				<ul className="mrgn_scrl_cont data_rows">
					{props.tableData.slice(0, props.numOfRows).map((row, index) => (
						<li className="tr" key={index}>
							<div className="td EdelCode robotoM">
								<span dangerouslySetInnerHTML={{ __html: row.EdelCode }}></span>
							</div>
							<div className="td Companyname">{row.Companyname}</div>
							<div className="td Haircut right">{toINR(row.Haircut)}</div>
						</li>
					))}
				</ul>
			) : (
				<NoDataContainer txtHeading="No results found" />
			)}
		</div>
	);
};

export default MarginCollateralTableDsk;
